<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-button @click="back()">
        <feather-icon icon="ArrowLeftIcon" svgClasses="h-4 w-4" />
        Regresar
      </vs-button>
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('document') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('frequency') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <th class="qb-sticky"></th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].document_name | capitalize }}
        </vs-td>
        <vs-td>
          {{ data[i].frequency_name | upperCase }}
        </vs-td>
        <vs-td>
          <vs-chip :color="data[i].status_color" v-if="data[i].documentation_id != null">
            {{ $t(data[i].status_name) | upperCase }}
          </vs-chip>
          <vs-chip v-else>
            {{  $t('disabled') | upperCase }}
          </vs-chip>
        </vs-td>
        <vs-td>
          <div>
            <span @click.stop="details(data[i])" style="cursor: pointer;" class="text-primary">Detalles</span>
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
    
    <script>
import ActionIcon from '@/components/ActionIcon.vue'

export default {
  components: {
    ActionIcon,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    back: function () {
      this.$emit('back')
    },
    infiniteHandler: function (isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search: function () {
      this.$emit('search', this.text)
    },
    details: function (item) {
      this.$emit('details', { ...item })
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
    
    <style>
</style>
    